import { HttpClientService } from './../httpClient/httpclient.service';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Observable } from 'rxjs/Observable';
import { CampaignService } from './campaign.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CouponHistoryService {
  baseUrl = 'koncentro-promo/campaign';
  couponId: string;

  constructor(
    private http: HttpClientService
  ) {

  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`${this.baseUrl}/coupon-audit?coupon_id=${this.couponId}&` + params.toString());
  }
 
  getCouponAuditLog() {
    return this.http.get(`${this.baseUrl}/coupon-audit?coupon_id=${this.couponId}`);
  }
}  


// WEBPACK FOOTER //
// ./src/app/services/campaign/coupon-history.service.ts